import "./style.css"
import "./jobs_styles.css"
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./job-react-files/App"

const root = ReactDOM.createRoot(document.getElementById("job-listing-react"))

root.render(<App />)
